<div>
    {{displayName | uppercase}}
</div>